import { ref } from 'vue'
import { toast } from 'vue-sonner'
import { commentsService } from '../../services/index.js'

export function useQuoteComments(quoteId) {
  const comments = ref([])
  const newComment = ref('')
  const addingComment = ref(false)

  const loadComments = async () => {
    try {
      const data = await commentsService.list(quoteId)
      comments.value = data.comments || []
    } catch (err) {
      console.error('Erreur lors du chargement des commentaires:', err)
    }
  }

  const addComment = async () => {
    if (!newComment.value.trim()) return
    
    addingComment.value = true
    try {
      await commentsService.create({
        quoteId: parseInt(quoteId),
        content: newComment.value.trim(),
        isPinned: false
      })
      
      newComment.value = ''
      await loadComments()
      toast.success('Commentaire ajouté avec succès')
    } catch (err) {
      toast.error('Erreur lors de l\'ajout du commentaire')
      console.error(err)
    } finally {
      addingComment.value = false
    }
  }

  const togglePin = async (commentId, pin) => {
    try {
      await commentsService.update(commentId, { isPinned: pin })
      await loadComments()
      toast.success(pin ? 'Commentaire épinglé' : 'Commentaire désépinglé')
    } catch (err) {
      toast.error('Erreur lors de la modification du commentaire')
      console.error(err)
    }
  }

  const editComment = async (commentId, content) => {
    try {
      await commentsService.update(commentId, { content })
      await loadComments()
      toast.success('Commentaire modifié avec succès')
    } catch (err) {
      toast.error('Erreur lors de la modification du commentaire')
      console.error(err)
    }
  }

  const deleteComment = async (commentId) => {
    if (!confirm('Êtes-vous sûr de vouloir supprimer ce commentaire ?')) {
      return
    }
    
    try {
      await commentsService.delete(commentId)
      await loadComments()
      toast.success('Commentaire supprimé avec succès')
    } catch (err) {
      toast.error('Erreur lors de la suppression du commentaire')
      console.error(err)
    }
  }

  return {
    comments,
    newComment,
    addingComment,
    loadComments,
    addComment,
    editComment,
    togglePin,
    deleteComment
  }
}

